<ng-container rtBlock="sc-viewport">
    <canvas #canvas></canvas>

    @if (!hideControls()) {
        <div rtElem="controls-bar">
            @if (controlsVisible()) {
                <div rtElem="controls" [rtMod]="{ zoom: true }">
                    <span rtElem="controls-label" i18n="@@viewportZoomGroup">Масштаб</span>
                    <div rtElem="zoom">
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Zoom in"
                            i18n-aria-label="@@viewportZoomIn"
                            [rtMod]="{ zoomIn: true }"
                            (pointerdown)="startZoom(1, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            +
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Zoom out"
                            i18n-aria-label="@@viewportZoomOut"
                            [rtMod]="{ zoomOut: true }"
                            (pointerdown)="startZoom(-1, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            −
                        </button>
                    </div>
                </div>

                <div rtElem="controls" [rtMod]="{ orbit: true }">
                    <span rtElem="controls-label" i18n="@@viewportOrbitGroup">Поворот</span>
                    <div rtElem="dpad">
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Rotate up"
                            i18n-aria-label="@@viewportOrbitUp"
                            [rtMod]="{ up: true }"
                            (pointerdown)="startOrbit(0, 1, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ▲
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Rotate left"
                            i18n-aria-label="@@viewportOrbitLeft"
                            [rtMod]="{ left: true }"
                            (pointerdown)="startOrbit(-1, 0, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ◀
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Rotate right"
                            i18n-aria-label="@@viewportOrbitRight"
                            [rtMod]="{ right: true }"
                            (pointerdown)="startOrbit(1, 0, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ▶
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Rotate down"
                            i18n-aria-label="@@viewportOrbitDown"
                            [rtMod]="{ down: true }"
                            (pointerdown)="startOrbit(0, -1, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ▼
                        </button>
                    </div>
                </div>

                <div rtElem="controls" [rtMod]="{ pan: true }">
                    <span rtElem="controls-label" i18n="@@viewportPanGroup">Сдвиг</span>
                    <div rtElem="dpad">
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Pan up"
                            i18n-aria-label="@@viewportPanUp"
                            [rtMod]="{ up: true }"
                            (pointerdown)="startPan(0, 1, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ▲
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Pan left"
                            i18n-aria-label="@@viewportPanLeft"
                            [rtMod]="{ left: true }"
                            (pointerdown)="startPan(-1, 0, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ◀
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Pan right"
                            i18n-aria-label="@@viewportPanRight"
                            [rtMod]="{ right: true }"
                            (pointerdown)="startPan(1, 0, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ▶
                        </button>
                        <button
                            rtElem="btn"
                            rtButton
                            type="button"
                            aria-label="Pan down"
                            i18n-aria-label="@@viewportPanDown"
                            [rtMod]="{ down: true }"
                            (pointerdown)="startPan(0, -1, $event)"
                            (pointerup)="stopHold()"
                            (pointercancel)="stopHold()">
                            ▼
                        </button>
                    </div>
                </div>
            }

            <button
                rtElem="toggle"
                rtButton
                type="button"
                aria-label="Toggle viewport controls"
                i18n-aria-label="@@viewportControlsToggle"
                qa-dataid="viewport-controls-toggle"
                [rtMod]="{ active: controlsVisible() }"
                [attr.aria-pressed]="controlsVisible()"
                (click)="toggleControls()">
                @if (controlsVisible()) {
                    ✕
                } @else {
                    ⋯
                }
            </button>
        </div>
    }
</ng-container>
